//libs
import React from 'react';

import { TFunction } from '@lyearn/i18n';
//components
import { Box, Button, LinkButton, Typography } from '@lyearn/ui';
import { Footer as DialogFooter } from '@/components/DialogComponent';

export const renderDialogFooter = ({
  t,
  onClose,
  onSubmit,
}: {
  t: TFunction;
  onClose: () => void;
  onSubmit: () => void;
}) => (
  <Box className="mt-16">
    <DialogFooter>
      <LinkButton className="py-2 px-4 me-24" onClick={onClose}>
        <Typography
          className="hover:text-interactive-primary-hover"
          color="text-text-placeholder"
          variant="heading-xxs">
          {t('Common:Actions.AskMeLater')}
        </Typography>
      </LinkButton>
      <Button onClick={onSubmit}>{t('Common:Actions.Submit')}</Button>
    </DialogFooter>
  </Box>
);
